import * as Long from "long";
export var selectPaymentEntryInfo = function (state) {
    return state.paymentInfo && state.paymentInfo.purchasedPackages
        ? Array.from(state.paymentInfo.purchasedPackages.values())
        : [];
};
export var selectIsOfferPurchased = function (state, offerCharacteristicId) {
    var paymentEntryInfo = state.paymentInfo.purchasedPackages.get(offerCharacteristicId);
    if (paymentEntryInfo == undefined) {
        return false;
    }
    return (paymentEntryInfo.amount != undefined &&
        Long.fromValue(paymentEntryInfo.amount).greaterThan(0));
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPaymentEntryInfo.ts
// module id = 587
// module chunks = 3